<template>
  <v-simple-table class="nocopypaste">
    <template v-slot:default>
      <thead v-if="accessRights.includes('all')">
        <th
          colspan="4"
          class="yellow lighten-4 py-1 px-4 text-right"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important"
        >
          <v-btn outlined small color="primary" @click="exportRaw">Export</v-btn>
        </th>
      </thead>
      <tbody>
        <tr class="pa-0" v-if="loading">
          <th colspan="8" class="pa-0" style="height:4px;">
            <v-progress-linear indeterminate></v-progress-linear>
          </th>
        </tr>

        <template v-for="c in benefitsCurrency">
          <tr v-bind:key="c.company + '|' + c.revenue + '|' + c.profit">
            <td
              :rowspan="companyNameRowSpan(c)"
              class="yellow lighten-4"
              style="font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
            >
              {{ c.company }} {{ c.positions[0].fy ? `(FY${c.positions[0].fy})` : '' }}
            </td>
            <template v-if="c.positions[0].benefits">
              <td
                :rowspan="c.positions[0].benefits.length"
                class="yellow lighten-5"
                style="font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
              >
                {{ c.positions[0].name | titleCase }}<br />({{ c.positions[0].title | titleCase }})
                <v-icon
                  @click="showRemarks(c.positions[0].remarks.trim())"
                  small
                  v-if="c.positions[0].remarks.trim()"
                  >info</v-icon
                >
                <v-icon
                  @click="showScreenshots(c.positions[0].countryCode, c.positions[0].screenshots)"
                  small
                  v-if="c.positions[0].screenshots && c.positions[0].screenshots.length > 0"
                  >image</v-icon
                >
              </td>
              <td
                style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                class="yellow lighten-4"
              >
                {{ c.positions[0].benefits[0].benefitType }} (p.a.)
              </td>
              <td
                style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                class="yellow lighten-5"
              >
                {{ c.positions[0].benefits[0].valAmt | currency }} ({{
                  c.positions[0].benefits[0].percenOfTotalCost
                }})
              </td>
            </template>
            <template v-if="c.positions[0].bands">
              <td
                :rowspan="c.positions[0].bands.length"
                class="yellow lighten-5"
                style="font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
              >
                {{ c.positions[0].name | titleCase }}<br />({{ c.positions[0].title | titleCase }})
                <v-icon
                  @click="showRemarks(c.positions[0].remarks.trim())"
                  small
                  v-if="c.positions[0].remarks.trim()"
                  >info</v-icon
                >
                <v-icon
                  @click="showScreenshots(c.positions[0].countryCode, c.positions[0].screenshots)"
                  small
                  v-if="c.positions[0].screenshots && c.positions[0].screenshots.length > 0"
                  >image</v-icon
                >
              </td>
              <td
                style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                class="yellow lighten-4"
              >
                {{ c.positions[0].bands[0].benefitType }} (p.a.)
              </td>
              <td
                style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                class="yellow lighten-5"
              >
                {{ c.positions[0].bands[0].text }}
              </td>
            </template>
          </tr>
          <template v-if="c.positions[0].benefits">
            <tr
              v-for="b in c.positions[0].benefits.slice(1)"
              :key="c.company + '|' + c.revenue + '|' + c.profit + '0' + b.benefitType"
            >
              <td
                style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                class="yellow lighten-4"
              >
                {{ b.benefitType }} (p.a.)
              </td>
              <td
                style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                class="yellow lighten-5"
              >
                {{ b.valAmt | currency }} ({{ b.percenOfTotalCost }})
              </td>
            </tr>
          </template>
          <template v-if="c.positions[0].bands">
            <tr
              v-for="b in c.positions[0].bands.slice(1)"
              :key="c.company + '|' + c.revenue + '|' + c.profit + '0' + b.benefitType"
            >
              <td
                style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                class="yellow lighten-4"
              >
                {{ b.benefitType }} (p.a.)
              </td>
              <td
                style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                class="yellow lighten-5"
              >
                {{ b.text }}
              </td>
            </tr>
          </template>
          <template v-for="(pos, i) in c.positions.slice(1)">
            <tr :key="c.company + '|' + c.revenue + '|' + c.profit + (i + 1) + pos.title">
              <template v-if="pos.benefits">
                <td
                  :rowspan="pos.benefits.length"
                  class="yellow lighten-5"
                  style="font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                >
                  {{ pos.name | titleCase }}<br />({{ pos.title | titleCase }})
                  <v-icon @click="showRemarks(pos.remarks.trim())" small v-if="pos.remarks.trim()"
                    >info</v-icon
                  >
                  <v-icon
                    @click="showScreenshots(pos.countryCode, pos.screenshots)"
                    small
                    v-if="pos.screenshots && pos.screenshots.length > 0"
                    >image</v-icon
                  >
                </td>
                <td
                  style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                  class="yellow lighten-4"
                >
                  {{ pos.benefits[0].benefitType }} (p.a.)
                </td>
                <td
                  style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                  class="yellow lighten-5"
                >
                  {{ pos.benefits[0].valAmt | currency }} ({{ pos.benefits[0].percenOfTotalCost }})
                </td>
              </template>
              <template v-if="pos.bands">
                <td
                  :rowspan="pos.bands.length"
                  class="yellow lighten-5"
                  style="font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                >
                  {{ pos.name | titleCase }}<br />({{ pos.title | titleCase }})
                  <v-icon @click="showRemarks(pos.remarks.trim())" small v-if="pos.remarks.trim()"
                    >info</v-icon
                  >
                  <v-icon
                    @click="showScreenshots(pos.countryCode, pos.screenshots)"
                    small
                    v-if="pos.screenshots && pos.screenshots.length > 0"
                    >image</v-icon
                  >
                </td>
                <td
                  style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                  class="yellow lighten-4"
                >
                  {{ pos.bands[0].benefitType }} (p.a.)
                </td>
                <td
                  style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                  class="yellow lighten-5"
                >
                  {{ pos.bands[0].text }}
                </td>
              </template>
            </tr>
            <template v-if="pos.benefits">
              <tr
                v-for="b in pos.benefits.slice(1)"
                :key="c.company + '|' + c.revenue + '|' + c.profit + (i + 1) + b.benefitType"
              >
                <td
                  style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                  class="yellow lighten-4"
                >
                  {{ b.benefitType }} (p.a.)
                </td>
                <td
                  style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                  class="yellow lighten-5"
                >
                  {{ b.valAmt | currency }} ({{ b.percenOfTotalCost }})
                </td>
              </tr>
            </template>
            <template v-if="pos.bands">
              <tr
                v-for="b in pos.bands.slice(1)"
                :key="c.company + '|' + c.revenue + '|' + c.profit + (i + 1) + b.benefitType"
              >
                <td
                  style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                  class="yellow lighten-4"
                >
                  {{ b.benefitType }} (p.a.)
                </td>
                <td
                  style="height:30px;font-size:0.8rem;border-color:rgba(0,0,0,0.12) !important;"
                  class="yellow lighten-5"
                >
                  {{ b.text }}
                </td>
              </tr>
            </template>
          </template>
        </template>
      </tbody>
      <v-dialog v-model="remarkDialogVisible" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Remarks
          </v-card-title>
          <v-card-text class="pt-5 grey--text text--darken-3">
            {{ remarks }}
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="screenshotsDialogVisible">
        <v-card color="grey">
          <v-card-title class="title grey lighten-2" primary-title>
            Screen Shots from Annual Report
          </v-card-title>
          <v-carousel :cycle="false" height="560">
            <v-carousel-item
              contain
              v-for="(screenshot, i) in screenshots"
              style="cursor:pointer;"
              @click="openImage(screenshot)"
              :key="i"
              :src="screenshot"
            >
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </v-dialog>
    </template>
  </v-simple-table>
</template>
<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import download from 'downloadjs';
import currency from '../util/currency';
import percentage from '../util/percentage';
import debounce from '../debounce';

const rows = [
  { value: 'salaryUSD', text: 'Salary' },
  { value: 'allowanceUSD', text: 'Allowance' },
  // { value: 'fixedCashUSD', text: 'Fixed Cash' },
  { value: 'bonusUSD', text: 'Bonus' },
  { value: 'discretionaryBonusUSD', text: 'Discretionary Bonus' },
  // { value: 'totalCashUSD', text: 'Total Cash' },
  { value: 'shareBasedPaymentUSD', text: 'Share-Based Payment' },
  { value: 'deferredCashUSD', text: 'Deferred Cash' },
  { value: 'stockAwardUSD', text: 'Stock Award' },
  { value: 'optionAwardUSD', text: 'Option Award' },
  { value: 'nonEquityUSD', text: 'Non Equity' },
  // { value: 'rawTotalDirectCompensationUSD', text: 'Total Direct Compensation' },
  { value: 'benefitsInKindUSD', text: 'Benefit-in-Kind' },
  // { value: 'totalRemunerationUSD', text: 'Total Remuneration' },
  { value: 'socialContributionUSD', text: 'Social Contribution' },
  { value: 'pensionUSD', text: 'Pension' },
  // { value: 'totalCostUSD', text: 'Total Cost' },
  { value: 'directorFeeUSD', text: 'Director Fee' },
  { value: 'otherUSD', text: 'Others' },
];

function titleCase(str) {
  let temp = str.replace(/(\r\n|\n|\r)/gm, ' ');
  temp = temp.toLowerCase().split(' ');
  for (let i = 0; i < temp.length; i += 1) {
    temp[i] = temp[i].charAt(0).toUpperCase() + temp[i].slice(1);
  }
  const str1 = temp.join(' ');
  temp = str1.split('/');
  for (let i = 0; i < temp.length; i += 1) {
    temp[i] = temp[i].charAt(0).toUpperCase() + temp[i].slice(1);
  }
  return temp.join('/');
}
function quoteString(str) {
  if (str.includes(',')) {
    return `"${str}"`;
  }
  return str;
}
export default Vue.extend({
  filters: {
    titleCase,
    currency,
  },
  props: {
    companyBenefits: {
      type: Array,
    },
    loading: Boolean,
    exchangeRate: Object,
    compensationComponent: String,
  },
  data() {
    return {
      remarkDialogVisible: false,
      remarks: '',
      screenshotsDialogVisible: false,
      screenshots: [],
    };
  },
  methods: {
    titleCase,

    openImage: debounce((img) => {
      const win = window.open(img, 'Image');
      win.focus();
    }, 10),

    exportRaw() {
      const csvRows = [];
      csvRows.push([
        'Company',
        'Title',
        'Name',
        'MRC Job Class',
        'Currency',
        'In Bands',
        'Upper Band',
        'Lower Band',
        'Salary Ratio',
        'Allowance Ratio',
        'Discretionary Bonus Ratio',
        'Share-Based Payment Ratio',
        'Deferred Cash Ratio',
        'Benefits-In-Kind Ratio',
        'Social Contribution Ratio',
        'Others Ratio',
        'Director Fee Ratio',
        'Basic Salary',
        'Allowance',
        'Bonus',
        'Discretionary Bonus',
        'Share-Based Payment',
        'Deferred Cash',
        'Stock Award',
        'Option Award',
        'Non-Equity',
        'Benefit-in-Kind',
        'Social Contribution',
        'Pension',
        'Director Fee',
        'Others',
      ]);
      this.companyBenefits.forEach((company) => {
        company.positions.forEach((pos) => {
          const row = [
            quoteString(company.company),
            quoteString(this.titleCase(pos.title)),
            quoteString(this.titleCase(pos.name)),
            pos.MRCJobClass,
            'USD',
            pos.isExact ? 'No' : 'Yes',
            pos.upperBandUSD,
            pos.lowerBandUSD,
            pos.salaryRatio,
            pos.allowanceRatio,
            pos.discretionaryBonusRatio,
            pos.shareBasedPaymentRatio,
            pos.deferredCashRatio,
            pos.benefitsInKindRatio,
            pos.socialContributionRatio,
            pos.otherRatio,
            pos.directorFeeRatio,
            pos.salaryUSD,
            pos.allowanceUSD,
            pos.bonusUSD,
            pos.discretionaryBonusUSD,
            pos.shareBasedPaymentUSD,
            pos.deferredCashUSD,
            pos.stockAwardUSD,
            pos.optionAwardUSD,
            pos.nonEquityUSD,
            pos.benefitsInKindUSD,
            pos.socialContributionUSD,
            pos.pensionUSD,
            pos.directorFeeUSD,
            pos.otherUSD,
          ];
          csvRows.push(row);
        });
      });
      let csvContent = 'data:text/csv;charset=utf-8,';
      csvRows.forEach((rowArray) => {
        const row = rowArray.join(',');
        csvContent += `${row}\r\n`;
      });
      download(csvContent, 'RawData.csv', 'text/csv');
    },
    companyNameRowSpan(company) {
      let count = 0;
      company.positions.forEach((pos) => {
        if (pos.benefits) {
          count += pos.benefits.length;
        }
        if (pos.bands) {
          count += pos.bands.length;
        }
      });
      return count;
    },
    showRemarks(remarks) {
      this.remarkDialogVisible = true;
      this.remarks = remarks;
    },
    showScreenshots(countryCode, screenshots) {
      this.screenshotsDialogVisible = true;
      this.screenshots = screenshots.map((screenshot) => encodeURI(`/exec-comp/api/screenshots/${countryCode[0]}/${screenshot}`));
    },
  },
  computed: {
    benefitsCurrency() {
      const { usdDivisor } = this.exchangeRate;
      const { compensationComponent } = this;
      const output = this.companyBenefits.map((cb) => ({
        ...cb,
        positions: cb.positions.map((pos) => {
          const totalCost = pos.totalCostUSD;
          if (pos.isExact === false) {
            const bands = rows
              .filter((r) => r)
              .map((component) => {
                const ratioKey = `${component.value.substr(0, component.value.length - 3)}Ratio`;
                const ratio = pos[ratioKey];
                if (!ratio) {
                  return {
                    benefitType: component.text,
                    text: '',
                    value: component.value,
                  };
                }
                const lower = pos.lowerBandUSD * ratio * usdDivisor;
                const upper = pos.upperBandUSD * ratio * usdDivisor;
                return {
                  benefitType: component.text,
                  text: `${currency(lower)} - ${currency(upper)} (${percentage(ratio * 100)})`,
                  value: component.value,
                };
              })
              .filter((b) => {
                if (!b.text) {
                  if (b.value !== compensationComponent) {
                    return false;
                  }
                }
                return true;
              });
            return {
              ...pos,
              bands,
            };
          }
          const benefits = rows
            .filter((r) => r)
            .map((component) => ({
              value: component.value,
              benefitType: component.text,
              valAmt: pos[component.value] * usdDivisor,
              percenOfTotalCost: totalCost
                ? `${percentage((pos[component.value] / totalCost) * 100)}`
                : 'NA',
            }))
            .filter((b) => {
              if (b.valAmt === 0) {
                if (b.value !== compensationComponent) {
                  return false;
                }
              }
              return true;
            });
          return {
            ...pos,
            benefits,
          };
        }),
      }));
      return output.filter((comp) => comp.positions.length > 0);
    },
    ...mapState(['accessRights']),
  },
});
</script>
<style lang="css" scoped>
.nocopypaste tr:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.nocopypaste {
  -webkit-user-select: none !important;
  -moz-user-select: -moz-none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}
</style>
